export const normalizeCoords = (coords: string | number[]) => {
  if (typeof coords !== 'string') {
    return coords;
  }

  return coords
    .split(' ')
    .join('')
    .split(',')
    .map((i) => parseFloat(i));
};
